import React, {Component} from "react";
import {BarChart} from "@mui/x-charts/BarChart";
import {cheerfulFiestaPalette, mangoFusionPalette} from "@mui/x-charts";

class ChartComponent extends Component {
    render() {
        try {
            const {jsonData} = this.props;

            // Filtriamo per rimuovere "Totali" e "Totale"
            const filteredData = jsonData.filter(entry => entry.data !== "Totali");
            const labels = filteredData.map(entry => entry.data);

            // Ottenere le chiavi senza "data" e "Totale"
            const keys = Object.keys(filteredData[0]).filter(k => k !== "data" && k !== "Totale");

            // Costruire i dati per le serie del grafico
            const series = keys.map(key => ({
                label: key.split(" ")[0], // Prendiamo solo il nome prima della data
                data: filteredData.map(entry => parseFloat(entry[key]))
            }));

            const height = Math.max(200, filteredData.length * 125);

            return (
                <BarChart
                    series={series}
                    height={height}
                    yAxis={[{data: labels, scaleType: "band"}]}
                    margin={{top: 60, bottom: 60, left: 60, right: 30}}
                    xAxis={[{label: "Euro"}]}
                    grid={{vertical: true}}
                    layout="horizontal"
                    colors={mangoFusionPalette}
                />
            );
        } catch (error) {
            console.error("Errore nel rendering del grafico:", error);
            return <div></div>;
        }

    }
}

export default ChartComponent;
